import { useSyncExternalStore } from 'react';

/**
 * Escopo de empresas escolhido no shell. Vazio = todas as empresas permitidas (o server
 * intersecta com o que a pessoa pode ver). Entra na chave da query E no parâmetro da requisição.
 */
const CHAVE = 'fiscoai:escopo-empresas';
const ouvintes = new Set<() => void>();
const VAZIO: readonly string[] = Object.freeze([]);

function ler(): readonly string[] {
  try {
    const bruto = globalThis.localStorage.getItem(CHAVE);
    const lista: unknown = bruto ? JSON.parse(bruto) : [];
    return Array.isArray(lista) ? lista.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

let atual: readonly string[] = ler();

export function definirEscopo(ids: readonly string[]): void {
  atual = ids.length === 0 ? VAZIO : Object.freeze([...ids]);
  try {
    globalThis.localStorage.setItem(CHAVE, JSON.stringify(atual));
  } catch {
    // sem storage: o escopo vale só nesta aba
  }
  for (const ouvinte of ouvintes) ouvinte();
}

function assinar(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => ouvintes.delete(ouvinte);
}

export function useEscopoEmpresas(): readonly string[] {
  return useSyncExternalStore(
    assinar,
    () => atual,
    () => VAZIO,
  );
}
